module.exports = __webpack_public_path__ + "img/Gas.43d6ac70.svg";